import React from 'react';
import { Button } from '../ui/button';
import { Check, Shield, Sparkles, Calendar, Star, Zap } from 'lucide-react';
import { pricingContent, LINKS } from '../../data/mock';

const PricingSection = () => {
  return (
    <section className="py-20 md:py-28 px-4 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-blue-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-80 h-80 bg-green-100/30 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-purple-50 to-pink-50 text-purple-600 text-sm font-semibold mb-6 border border-purple-100 shadow-sm">
            <Sparkles className="w-4 h-4" />
            Oferta Exclusiva
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {pricingContent.title}
          </h2>
        </div>

        {/* Pricing Card */}
        <div className="bg-white rounded-3xl shadow-2xl border-2 border-[#007AFF] overflow-hidden relative">
          {/* Popular Badge */}
          <div className="absolute top-0 right-0 bg-gradient-to-r from-[#007AFF] to-blue-600 text-white px-8 py-3 rounded-bl-3xl text-sm font-bold shadow-lg">
            <div className="flex items-center gap-2">
              <Star className="w-4 h-4 fill-white" />
              Más Popular
            </div>
          </div>

          {/* Glow Effect */}
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-blue-400/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-green-400/20 rounded-full blur-3xl"></div>

          <div className="relative p-8 md:p-12">
            {/* Price */}
            <div className="text-center mb-10">
              <div className="flex items-center justify-center !mt-[8px] !mb-[15px] !gap-[16px]">
                <span className="text-6xl md:text-7xl font-extrabold text-gray-900">{pricingContent.setupPrice}</span>
                <div className="text-left">
                  <span className="block text-gray-500 text-lg font-medium">Setup</span>
                  <span className="block !text-sm text-gray-400">Pago único</span>
                </div>
              </div>
              <div className="flex items-center justify-center gap-2 text-gray-600">
                <span className="text-3xl font-bold text-[#007AFF]">+ {pricingContent.monthlyPrice}</span>
                <span className="!text-lg">mantenimiento y hosting</span>
              </div>
            </div>

            {/* Benefits */}
            <div className="grid md:grid-cols-2 gap-4 mb-10">
              {pricingContent.benefits.map((benefit, index) =>
              <div key={index} className="flex items-start gap-3 group p-2 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="w-6 h-6 rounded-full bg-gradient-to-br from-emerald-100 to-green-100 flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform shadow-sm">
                    <Check className="w-4 h-4 text-emerald-600" />
                  </div>
                  <span className="!text-[#2B3240]">{benefit}</span>
                </div>
              )}
            </div>

            {/* Guarantee */}
            <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl p-6 mb-8 flex items-start gap-4 border border-amber-200 shadow-sm">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-100 to-yellow-100 flex items-center justify-center flex-shrink-0 shadow-inner">
                <Shield className="w-7 h-7 text-amber-600" />
              </div>
              <div>
                <p className="font-bold text-gray-900 mb-1 flex items-center gap-2">
                  <Zap className="w-4 h-4 text-amber-500" />
                  Garantía Total
                </p>
                <p className="!text-base text-gray-700">{pricingContent.guarantee}</p>
              </div>
            </div>

            {/* CTA */}
            <a href={LINKS.calendar} target="_blank" rel="noopener noreferrer" className="block">
              <Button
                size="lg"
                className="w-full bg-gradient-to-r from-[#007AFF] to-blue-600 hover:from-[#0056b3] hover:to-blue-700 text-white py-7 text-lg font-bold rounded-xl shadow-xl shadow-blue-500/30 hover:shadow-2xl hover:shadow-blue-500/40 transition-all duration-300 hover:-translate-y-0.5">

                <Calendar className="w-5 h-5 mr-2" />
                Reservar Mi Implementación
              </Button>
            </a>

            <p className="text-center text-gray-500 text-sm mt-4">
              Sin compromiso. Agenda una llamada y te explicamos todo.
            </p>
          </div>
        </div>
      </div>
    </section>);

};

export default PricingSection;